export default __webpack_public_path__ + "static/media/adaptation.c5590f54.webp";